import type { Phone } from "@finn-no/mobility-dealer-types";
import { Trans, useLingui } from "@lingui/react";
import { useScreenSize } from "@mobility-item-page/client";
import { Intent } from "@mobility-item-page/utilities/client";
import { toast } from "@warp-ds/elements/toast";
import { Button } from "@warp-ds/react";
import { useState } from "react";
import { trackPhone, trackShowPhone } from "src/utils/pulseHelper.ts";
import { useOrganisation } from "../../../context/DealerDataProviderContext.tsx";
import { copyToClipboard } from "../../Utils/copyToClipboard.ts";

interface PhonenumberProps {
  phone?: Phone;
  fixedPhoneNumber?: string;
}

export const Phonenumber = ({ phone, fixedPhoneNumber }: PhonenumberProps) => {
  const { i18n } = useLingui();
  const { isMobile } = useScreenSize();
  const { name } = useOrganisation();
  const [phoneHidden, setPhoneHidden] = useState(true);
  const [text, setText] = useState<string | undefined>(
    i18n.t({ id: "dealerBrandingLayout.actions.phonenumber.show", message: "Show phone number" }),
  );

  const resolvedPhone = fixedPhoneNumber || phone?.phoneNumberFallback;

  if (!resolvedPhone) {
    return null;
  }

  const onDesktopClick = () => {
    if (phoneHidden) {
      trackShowPhone(name);
      setPhoneHidden(false);
      setText(resolvedPhone);
    } else {
      trackPhone(Intent.Click, `tel:${resolvedPhone}`, name);
      copyToClipboard(resolvedPhone);
      toast(
        i18n.t({
          id: "dealerBrandingPage.actions.phonenumber.copied",
          message: "Copied",
        }),
      );
    }
  };

  if (fixedPhoneNumber) {
    return isMobile ? (
      <Button
        secondary
        fullWidth
        className="whitespace-nowrap md:min-w-[170px]"
        href={`tel:${fixedPhoneNumber}`}
        onClick={() => trackPhone(Intent.Call, `tel:${fixedPhoneNumber}`, name)}
      >
        <Trans id="dealerBrandingPage.actions.phonenumber.call" message="Call seller" />
      </Button>
    ) : (
      <Button
        secondary
        fullWidth
        className="whitespace-nowrap flex items-center md:min-w-[170px]"
        onClick={onDesktopClick}
      >
        {text}
      </Button>
    );
  }
  if (phone) {
    return isMobile ? (
      <Button
        link
        className="whitespace-nowrap"
        href={`tel:${phone.phoneNumberFallback}`}
        onClick={() => trackPhone(Intent.Call, `tel:${phone.phoneNumberFallback}`, name)}
      >
        {phone.phoneNumberDirectCallText ? (
          phone.phoneNumberDirectCallText
        ) : (
          <Trans id="dealerBrandingPage.actions.phonenumber.call" message="Call seller" />
        )}
      </Button>
    ) : (
      <Button link className="whitespace-nowrap flex items-center" onClick={onDesktopClick}>
        {text}
      </Button>
    );
  }
};
